import type { AthleteUpdate } from '@/api/athletesApi'

export function athleteAge(birth?: string, now = new Date()): number | null {
  if (!birth) return null
  const [y, m, d] = birth.slice(0, 10).split('-').map(Number)
  if (!y || !m || !d) return null
  const check = new Date(y, m - 1, d)
  if (check.getFullYear() !== y || check.getMonth() + 1 !== m || check.getDate() !== d) return null
  return now.getFullYear() - y - (now.getMonth() + 1 < m || (now.getMonth() + 1 === m && now.getDate() < d) ? 1 : 0)
}

// The server deliberately ignores empty scalar fields; never report such edits as saved.
export function unsupportedAthleteClear(patch: AthleteUpdate): boolean {
  return (['name', 'phone', 'parent_phone', 'date_of_birth'] as const)
    .some(key => key in patch && !String(patch[key] ?? '').trim())
}

export function retainFailedDrafts(drafts: Record<string, AthleteUpdate>, completed: string[]): Record<string, AthleteUpdate> {
  return Object.fromEntries(Object.entries(drafts).filter(([id]) => !completed.includes(id)))
}
